import React, { Component } from 'react'
import { Provider } from 'react-redux'
import './_styles.scss'
import BrandHeader from './Components/BrandHeader'
import MainMenu from './Components/MainMenu'
import { MAIN_MENU, PartidosTab } from './constants'
import { createMundialStore } from './store'
import { back, setHeaderVisible } from './store/actions'
import Device from '../../devices/device'
import { getNodeCode, getTabComponent, getPhase2Config } from './utils'

class Mundial2026 extends Component {
  constructor (props) {
    super(props)
    // Store local: sólo visible para el árbol de Mundial2026 vía su propio Provider.
    this.mundialStore = createMundialStore()
    this.contentEl = null
    this.keys = Device.getDevice().getKeys()

    this.state = {
      activeTab: PartidosTab,
      tabReloadKey: 0
    }

    this.nodeCode = getNodeCode()
    this.region = localStorage.getItem('region')
    this.isPhase2Enabled = getPhase2Config()
  }

  componentDidMount () {
    document.addEventListener('keydown', this.handleBack, true)
    document.addEventListener('keydown', this.handleUpFromBelow, true)
    this.setBackground()
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.handleBack, true)
    document.removeEventListener('keydown', this.handleUpFromBelow, true)
    this.setBackground(true)
  }

  // Cuando el foco está en un carrusel debajo de Mundial2026 y se presiona UP,
  // la navegación espacial suba hasta la nav de fases de grupo.
  handleUpFromBelow = (e) => {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (!currentKey || currentKey !== 'UP') return

    // Solo aplica cuando Partidos está en vista
    if (this.state.activeTab !== PartidosTab) return

    const contentEl = this.contentEl
    if (!contentEl) return

    // Si el foco ya está dentro de mundial2026, no intervenir
    if (contentEl.contains(document.activeElement)) return

    const activeEl = document.activeElement
    if (!activeEl) return

    const contentRect = contentEl.getBoundingClientRect()
    const activeRect = activeEl.getBoundingClientRect()

    // Solo actuar si el elemento activo está debajo de mundial2026
    if (activeRect.top < contentRect.bottom) return

    // Solo actuar si el foco está en el PRIMER carrusel debajo de mundial2026:
    // busca todos los focusables por debajo de mundial2026 y compara la posición
    // vertical del activo con la del primer grupo (tolerancia de 60px de altura de fila).
    const allBelow = Array.from(
      document.querySelectorAll('.focusable, button, [tabindex]:not([tabindex="-1"])')
    ).filter(el => {
      if (contentEl.contains(el)) return false
      return el.getBoundingClientRect().top >= contentRect.bottom
    })
    if (!allBelow.length) return
    const minTop = Math.min(...allBelow.map(el => el.getBoundingClientRect().top))
    if (activeRect.top > minTop + 60) return

    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    if (!this.isPhase2Enabled) {
      const target = document.querySelector('.partidos__content .focusable')
      if (target) target.focus()
      return
    }

    const fasesContent = document.querySelector('.fases-content')
    const secondChild = fasesContent && fasesContent.children[1]
    const focusables = secondChild && secondChild.querySelectorAll('.focusable')
    const target = focusables && (focusables[1] || focusables[0])
    if (target) target.focus()
  }

  // Listener nativo con capture:true — se ejecuta antes que el listener del router.
  // Consume el BACK si hay historial interno; si no, lo deja pasar al router.
  handleBack = (e) => {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (!currentKey || currentKey !== 'BACK') return

    const contentEl = this.contentEl
    if (!contentEl || !contentEl.contains(document.activeElement)) return

    const { history } = this.mundialStore.getState()
    if (history.length === 0) return // sin historial → deja pasar al router

    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    // La entrada que sale del history queda en pendingRestore;
    // el hijo conectado la leerá en componentDidUpdate y aplicará el restore.
    this.mundialStore.dispatch(back())

    // Si el restore pertenece a otra sección de la nav, cambiar la tab activa.
    // dispatch es síncrono, por lo que el estado ya fue actualizado aquí.
    const { pendingRestore } = this.mundialStore.getState()
    if (pendingRestore && pendingRestore.section !== this.state.activeTab) {
      this.setState({ activeTab: pendingRestore.section })
    }
  }

  setBackground(remove) {
    const container = document.querySelector('.container')
    const containerClass = 'mundial2026__container'
    if (container) {
      remove ? 
        container.classList.remove(containerClass) : 
        container && container.classList.add(containerClass)
    }
  }

  onChangeTab = (tabId) => {
    const { activeTab, tabReloadKey } = this.state
    if (tabId === activeTab) {
      this.setState({ tabReloadKey: tabReloadKey + 1 })
      return
    }
    this.setState({ activeTab: tabId })
  }

  render () {
    const items = MAIN_MENU

    const { activeTab, tabReloadKey } = this.state

    const tabContent = getTabComponent(activeTab, tabReloadKey)
    return (
      <Provider store={this.mundialStore}>
        <div className='mundial2026' ref={(el) => { this.contentEl = el }}>
          <div className='mundial2026__content'>
            <BrandHeader 
              region={this.region} 
              nodeCode={this.nodeCode} 
            />
            {
              this.isPhase2Enabled && 
                <MainMenu 
                  items={items} 
                  activeTab={activeTab} 
                  onItemClick={this.onChangeTab} 
                  onHeaderToggle={(visible) => this.mundialStore.dispatch(setHeaderVisible(visible))} 
                />
            }
            <div className='main-content' style={{height: '100%'}}>
              {tabContent}
            </div>

          </div>
        </div>
      </Provider>
    )
  }
}

export default Mundial2026


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/index.jsx